export const isGuarantor = () => window?.location.pathname.includes('/avalista/')
